var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-folder-btn upload-btn",on:{"click":_vm.toUploadFolder}},[_vm._t("default",[_c('button',{staticClass:"upload-folder-default upload-default",attrs:{"type":"button","name":"upload-folder-btn"}},[_vm._v("选择文件夹")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2710ed6f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploadFolder.vue
// module id = 100
// module chunks = 0